import isEmpty from 'lodash/isEmpty'
import * as Newsbrief from '../'
import * as Constants from './constants'

const asUpdate = (action: Newsbrief.UpdateStateAction): Newsbrief.UpdateStateAction => {
  return {
    ...action,
    isActive: !isEmpty(action.value),
  }
}

export const updateCount: Newsbrief.StateUpdateActionCreator =
  (action: Newsbrief.UpdateStateAction) => {
  if (isEmpty(action.rowId)) {
    return ({
      type: Constants.ADD_NEWSBRIEF_COUNT,
      ...action,
    })
  } else {
    return ({
      type: Constants.UPDATE_NEWSBRIEF_COUNT,
      ...asUpdate(action),
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/newsbrief/counts/actions.ts